<template>
    <div>
        <div class="page-filter-box">
            <el-row :gutter="20">
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-input v-model="params.searchValue" class="input-with-select" size="small">
                        <el-select v-model="params.searchType" slot="prepend" placeholder="请选择">
                            <el-option label="演出ID" :value="1"></el-option>
                            <el-option label="订单编号" :value="2"></el-option>
                            <el-option label="退款任务ID" :value="3"></el-option>
                        </el-select>
                    </el-input>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.refundStatus" placeholder="请选择" size="small">
                        <el-option label="仅看待退款的" :value="1"></el-option>
                        <el-option label="仅看退款中的" :value="2"></el-option>
                        <el-option label="仅看退款失败的" :value="4"></el-option>
                        <el-option label="仅看退款成功的" :value="3"></el-option>
                        <el-option label="不限制退款状态" :value="-1"></el-option>
                    </el-select>
                </el-col>
				<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
				    <el-select v-model="params.activityChannel" placeholder="不限制演出来源" class="fl fl-big-select" clearable size="small">
						<el-option label="不限制演出来源" value=""></el-option>
				        <el-option v-for="(item, index) in activityChannel" :label="item.value" :key="index" :value="item.key"></el-option>
				    </el-select>
				</el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <!-- <el-select v-model="params.payPlatformCode" placeholder="请选择" size="small">
                        <el-option label="不限制支付平台" :value="-1"></el-option>
                        <el-option label="仅看支付宝的" :value="1"></el-option>
                        <el-option label="仅看微信支付的" :value="2"></el-option>
                        <el-option label="仅看财付通的" :value="3"></el-option>
                        <el-option label="仅看微信-抖音小程序的" :value="5"></el-option>
                        <el-option label="仅看支付宝-抖音小程序的" :value="6"></el-option>
						<el-option label="仅看云闪付的" :value="7"></el-option>
						<el-option label="仅看云闪付-支付宝的" :value="10"></el-option>
						<el-option label="仅看云闪付-微信的" :value="11"></el-option>
						<el-option label="仅看微信-小红书小程序的" :value="8"></el-option>
						<el-option label="仅看支付宝-小红书小程序的" :value="9"></el-option>
						<el-option label="仅看美团小程序的" :value="12"></el-option>
                    </el-select> -->
					<el-select v-model="params.payPlatformCode" placeholder="不限制支付渠道" class="fl fl-big-select" clearable size="small">
						<el-option label="不限制支付渠道" value=""></el-option>
					    <el-option v-for="(item, index) in Paymentgateway" :label="item.value" :key="index" :value="item.key"></el-option>
					</el-select>
                </el-col>				
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.isAdvanceBalance" placeholder="请选择" size="small">
                        <el-option label="不限制提前结款状态" :value="-1"></el-option>
                        <el-option label="仅看未提前结款的" :value="0"></el-option>
                        <el-option label="仅看已提前结款的" :value="1"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.balanceType" placeholder="请选择" size="small">
                        <el-option label="不限制结算方式" :value="-1"></el-option>
                        <el-option label="仅看预付款的" :value="1"></el-option>
                        <el-option label="仅看后付款的" :value="2"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.partner" placeholder="请选择" size="small">
                        <el-option label="不限制业务渠道" value=""></el-option>                        
						<el-option label="仅看秀动的" value="showstart"></el-option>
						<el-option label="仅看非秀动的" value="notshowstart"></el-option>
						<el-option v-for="(item,index) in thirdAccount" :key="index" :label="`仅看${item.thirdName}的`" :value="item.source"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="16" :lg="11" :xl="8">
                    <div class="clearfix timeType">
                        <el-input class="input-with-select fl" size="small">
                            <el-select v-model="params.timeType" slot="prepend" placeholder="请选择">
                                <el-option label="售后开启时间" :value="1"></el-option>
                                <el-option label="退款成功时间" :value="2"></el-option>
                                <el-option label="取消时间" :value="3"></el-option>
                            </el-select>
                        </el-input>
                        <el-date-picker
                            v-model="params.time"
                            type="datetimerange"
                            start-placeholder="开始时间"
                            end-placeholder="结束时间"
                            class="fl"
                            size="small"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            unlink-panels
                            :default-time="['00:00:00', '23:59:59']"
                            >
                        </el-date-picker>
                    </div>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="5" :xl="4" class="page-filter-btns">
                    <el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
                    <el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
                </el-col>
            </el-row>
        </div>
        <div class="page-btns-box">
            <el-button  type="primary"  size="small" @click="batchRefund" :loading="batchRefundLoading">一键批量退款</el-button>
            <el-button  type="primary"  size="small" @click="importBatchRefund">导入批量退款</el-button>
			<el-button  type="primary"  size="small" @click="overdueBatchRefund">超期批量退款</el-button>
            <el-button  type="primary"  size="small" @click="viewBatchRefund">查看批量退款任务</el-button>
            <el-button  type="primary"  size="small" @click="exportData" :loading="exportDataLoading">导出</el-button>
        </div>
        <div class="page-list-box">
            <el-table
                :data="dataList"
                border
                style="width: 100%"
                v-loading="listLoading"
                size="small"
                stripe
            >
                <el-table-column prop="refundStatus" label="退款状态" :width="80">
                    <template slot-scope="scope">
                        <span v-if="scope.row.refundStatus == 0">无</span>
                        <span v-else-if="scope.row.refundStatus == 1">待退款</span>
                        <span v-else-if="scope.row.refundStatus == 2">退款中</span>
                        <span v-else-if="scope.row.refundStatus == 3" class="color-success">退款成功</span>
                        <span v-else-if="scope.row.refundStatus == 4" class="color-danger">退款失败</span>
                    </template>
                </el-table-column>
                <el-table-column prop="orderSn" label="订单编号" show-overflow-tooltip :min-width="150"></el-table-column>
                <el-table-column prop="payPlatformCodeName" label="支付平台" :min-width="140">
                    <!-- <template slot-scope="scope">
                        <span v-if="scope.row.payPlatformCode == 1">支付宝</span>
                        <span v-else-if="scope.row.payPlatformCode == 2">微信</span>
                        <span v-else-if="scope.row.payPlatformCode == 3">财付通</span>
                        <span v-else-if="scope.row.payPlatformCode == 5">微信-抖音小程序</span>
                        <span v-else-if="scope.row.payPlatformCode == 6">支付宝-抖音小程序</span>
						<span v-else-if="scope.row.payPlatformCode == 7">云闪付</span>
						<span v-else-if="scope.row.payPlatformCode == 8">微信-小红书小程序</span>
						<span v-else-if="scope.row.payPlatformCode == 9">支付宝-小红书小程序</span>
						<span v-else-if="scope.row.payPlatformCode == 10">云闪付-支付宝</span>
						<span v-else-if="scope.row.payPlatformCode == 11">云闪付-微信</span>
						<span v-else-if="scope.row.payPlatformCode == 12">美团小程序</span>
                    </template> -->
                </el-table-column>                
				<el-table-column prop="incomeAmountFormat" label="订单实际收入" :min-width="100"></el-table-column>
				<el-table-column label="退票手续费（比例）" :min-width="150">
					<template slot-scope="scope">
						{{scope.row.refundFeeStr}} （{{scope.row.refundFeeRatioStr}}）
					</template>
				</el-table-column>
                <el-table-column label="应退金额">
                    <template slot-scope="scope">
						{{scope.row.refundAmountFormat}}
                        <!-- <span v-if="scope.row.refundStatus == 1">{{scope.row.incomeAmountFormat}}</span>
                        <span v-else-if="scope.row.refundStatus == 3">{{scope.row.refundAmountFormat}}</span> 14903029 需求修改 -->
                    </template>
                </el-table-column>
                <!-- <el-table-column label="退款金额">
                    <el-table-column prop="incomeAmountFormat" label="待退款金额" :min-width="100"></el-table-column>
                    <el-table-column prop="refundAmountFormat" label="已退款金额" :min-width="100"></el-table-column>
                </el-table-column> -->
                <el-table-column prop="cancelTime" label="取消时间" :min-width="150"></el-table-column>
                <el-table-column prop="refundTime" label="退款成功时间" :min-width="150"></el-table-column>
                <el-table-column prop="refundOrderNo" label="退款流水号" :min-width="155" show-overflow-tooltip></el-table-column>
                <el-table-column prop="activityId" label="演出ID" :min-width="100"></el-table-column>
                <el-table-column prop="activityName" label="演出名称" show-overflow-tooltip :min-width="150"></el-table-column>
                <el-table-column prop="isAdvanceBalance" label="提前结款状态" :width="100">
                    <template slot-scope="scope">
                        <span v-if="scope.row.isAdvanceBalance == 1">已提前结款</span>
                        <span v-else-if="scope.row.isAdvanceBalance == 0">未提前结款</span>
                    </template>
                </el-table-column>
                <el-table-column prop="balanceType" label="结算方式" :width="80">
                    <template slot-scope="scope">
                        <span v-if="scope.row.balanceType == 1">预付款</span>
                        <span v-else-if="scope.row.balanceType == 2">后付款</span>
                    </template>
                </el-table-column>
                <el-table-column prop="taskId" label="所属退款任务" :min-width="100"></el-table-column>
                <el-table-column fixed="right" label="操作" :width="150">
                    <template slot-scope="scope">
                        <el-button
                            v-if="scope.row.refundStatus === 1 || scope.row.refundStatus === 4"
                            type="text"
                            size="small"
                            @click="refund(scope.row)"
                            >退款</el-button>
                        <el-button
                            v-if="scope.row.refundStatus === 4"
                            type="text"
                            size="small"
                            @click="viewFailureReason(scope.row)"
                            >查看失败原因</el-button>    
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div v-if="data" class="page-pagination-box">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="getDataList"
                :current-page.sync="params.pageNo"
                :page-sizes="$pageSizes"
                :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="data.totalCount || 0">
            </el-pagination>
        </div>
        <BatchRefund ref="batchRefund" @subSuccess="batchRefundSuccess"></BatchRefund>
        <BatchImport ref="batchImport"  @onUpdate="getDataList"></BatchImport>
		<OverRefund ref="overRefund"  @onUpdate="getDataList"></OverRefund>
    </div>
</template>

<script>
import BatchRefund from './components/BatchRefund';
import BatchImport from './components/BatchImport';
import OverRefund from './components/OverRefund';
import {fetchThirdAccount,fetchPayList} from '@/assets/js/commonApi';
// import {downloadFileTmp} from '@/assets/js/commonApi.js';

export default {
    components:{
        BatchRefund, BatchImport, OverRefund
    },
    data(){
        this.defaultParams = {
            // 1=演出ID 2=订单编号 3=退款任务ID
            searchType: 1,
            // 搜索内容
            searchValue: null,
            // 时间搜索类型 1=售后开启时间 2=退款成功时间 3=取消时间
            timeType: 3,
            // 时间
            time: null,
            // -1：全部 1：待退款 2：退款中 3：退款成功 4：退款失败
            refundStatus: 1,
            // 支付平台 -1=全部 1=支付宝 2=微信 3=财付通
            payPlatformCode:'',
            // 提前结款 -1:查询全部 0:否 1：是
            isAdvanceBalance: -1,
            // 结算方式 -1=全部 1:预付款 2:后付款
            balanceType: -1,
            pageNo: 1,
            pageSize: this.$pageSizes[0],
            partner: '',
			activityChannel:''
        };

        return {
            data: null,
            dataList: null,
            params:{
                ...this.defaultParams,
                searchType: parseInt(this.$route.query.searchType || 1),
                searchValue: this.$route.query.searchValue || null,
                timeType: parseInt(this.$route.query.timeType || 3),
                time: this.$route.query.timeBegin && this.$route.query.timeEnd ? [this.$route.query.timeBegin, this.$route.query.timeEnd] : null,
                refundStatus: parseInt(this.$route.query.refundStatus || 1),
                payPlatformCode: parseInt(this.$route.query.payPlatformCode) || '',
                isAdvanceBalance: parseInt(this.$route.query.isAdvanceBalance || this.$route.query.isAdvanceBalance == 0 ? this.$route.query.isAdvanceBalance : -1),
                balanceType: parseInt(this.$route.query.balanceType || -1),
                pageNo: parseInt(this.$route.query.pageNo || 1),
                pageSize: parseInt(this.$route.query.pageSize || this.$pageSizes[0]),
                partner: this.$route.query.partner || '',
            },
            listLoading: true,
            filter: null,
            exportDataLoading: false,
            batchRefundVisible: false,
            batchRefundLoading: false,
            thirdAccount:[],
			activityChannel:[],
			Paymentgateway:[]
        }
    },
    mounted() {
        this.getThirdAccount();
        this.getDataList();
		this.fetchPayList();
		this.getChannel()
    },
    methods:{
        //获取第三方平台
        getThirdAccount(){
            fetchThirdAccount({isThird:1})
                .then((res) => {
                    const { state, result } = res.data;
                    if (state == 1 && result) {
                        this.thirdAccount = result.thirdAccounts || [];
                    } else {
                        // this.$message.error(msg || "请求失败");
                    }
                })
        },
		async fetchPayList() {
		    const res = await fetchPayList({
		        
		    }).catch(() => {
		        return {data: {state: '0', msg: '请求错误'}};
		    });
		
		    const { state, msg, result} = res.data;
		
		    if(state !== '1') {
		        return this.$message.error(msg || '请求失败');
		    }
		
		    this.Paymentgateway = result || []
		    console.log(this.Paymentgateway)
		},
		//获取演出渠道
		getChannel() {
			this.$request({
				url: "/common/activitySource",
				method: "post",
				
			}).then(res => {
				const { state, result } = res.data;
				if (state == 1) {
					this.activityChannel = result || []
				}
			})
		},
        //获取列表
        async getDataList() {
            const {time, pageNo, pageSize, ...filter} = this.params;
            const [timeBegin, timeEnd] = time || [];

            this.listLoading = true;

            const res = await this.$request({
                url: '/activity/refund/list',
                method: 'post',
                data: {...filter, timeBegin, timeEnd, pageNo, pageSize}
            }).catch(() => {
                return {data: {state: '0', msg: '请求错误'}};
            }).finally(() => {
                this.listLoading = false;
            });

            const { state, msg, result } = res.data;

            if(state !== '1') {
                return this.$message.error(msg || '请求失败');
            }

            this.data = result;
            this.dataList = result.result || [];

            this.filter = {...filter, timeBegin, timeEnd};
        },
         //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getDataList();
        },
        //搜索
        search() {
            this.params.pageNo = 1;
            this.getDataList();
        },
        //重置搜索
        reset() {
            this.params = {
                ...this.defaultParams,
                pageSize: this.params.pageSize,
            };
            this.getDataList();
        },
        // 退款
        async refund(row) {
            const {refundAmountFormat, id, orderSn} = row;

            let confirmMsg = "";

            const res1 = await this.$request({
                url: '/activity/refund/refundCheck',
                method: 'post',
                params: {sn: orderSn}
            }).catch(() => {
                return {data: {state: '0', msg: '请求错误'}};
            });

            if(res1.data.state != 1){
                return this.$message.error(res1.data.msg || '请求失败');
            }else{
                if( res1.data.result ){
                    confirmMsg = `<p class='color-danger'>${res1.data.result}</p>` + confirmMsg;
                }
            }
            confirmMsg += `<p>确认退款金额：${refundAmountFormat}</p><p>确认退款后，系统将自动进行退款，资金会原路返回至用户账户对于已经在支付平台成功退款的订单，则系统会自动退款状态，<span class="color-danger">但不会进行资金上的重复退款</span></p>`;

            const flag = await this.$confirm(confirmMsg, '确认退款', {
                confirmButtonText: '确认退款',
                cancelButtonText: '取消',
                type: 'warning',
                center: true,
                closeOnClickModal: false,
                dangerouslyUseHTMLString: true,
            }).catch(() => {
                return 'cancel';
            });

            if(flag === 'cancel') {
                return;
            }

            const res = await this.$request({
                url: '/order/refund/confirmRefund',
                method: 'post',
                params: {id}
            }).catch(() => {
                return {data: {state: '0', msg: '请求错误'}};
            });

            const { state, msg } = res.data;

            if(state !== '1') {
                return this.$message.error(msg || '请求失败');
            }

            this.getDataList();
        },
        // 一键批量退款
        async batchRefund() {
            const {filter} = this;

            if(!filter) {
                return this.$message.error('没有可以操作的数据');
            }

            this.batchRefundLoading = true;

            const res = await this.$request({
                url: '/activity/refund/batch/checkOrderV2',
                method: 'post',
                data: {...filter}
            }).catch(() => {
                return {data: {state: '0', msg: '请求错误'}};
            }).finally(() => {
                this.batchRefundLoading = false
            });

            const { state, msg , result} = res.data;

            if(state !== '1') {
                this.$alert(msg, '提示', {
                    confirmButtonText: '确认',
                    dangerouslyUseHTMLString: true,
                    type: 'info',
                    center: true
                });

                return;
            }

            // const {notRefundList, refundList} = result;
            
            this.$refs.batchRefund.show(result, filter);
        },
        async batchRefundSuccess() {
            const flag = await this.$confirm('已生成批量退款任务，退款正在进行中，请耐心等待任务完成', '批量退款确认', {
                confirmButtonText: '确认',
                cancelButtonText: '查看任务',
                type: 'success',
                center: true,
                closeOnClickModal: false,
                showClose: false,
            }).catch(() => {
                return 'cancel';         
            });

            if(flag === 'cancel') {
                this.viewBatchRefund();
            }else{
                return this.getDataList();
            }
            
        },
        // 查看失败原因
        viewFailureReason(row) {
            const {resultDesc} = row;
            const [reason = '', recommended = ''] = (resultDesc || '').split('<br>');

            const h = this.$createElement;
            const msg = [h('p', null, reason)];

            recommended && msg.push(h('p', null, recommended));

            this.$alert(h('div', null, msg), '退款失败原因', {
                confirmButtonText: '知道了',
                dangerouslyUseHTMLString: true,
                type: 'info',
                center: true
            });
        },
        // 导入批量退款
        importBatchRefund() {
            this.$refs.batchImport.show();
        },
		//超期批量退款
		overdueBatchRefund(){
			this.$refs.overRefund.show();
		},
        // 查看批量退款任务
        viewBatchRefund() {
            this.$router.push({path: '/finance/batchRefundTask'});
        },
        // 导出
        async exportData() {
            const {filter} = this;

            if(!filter) {
                return this.$message.error('没有可以操作的数据');
            }

            this.exportDataLoading = true;

            const res = await this.$request({
                url:'/activity/refund/batch/export',
                method: 'post',
                data: filter,
            }).catch(() => {
                return {data: {state: '0', msg: '请求错误'}};
            }).finally(() => {
                this.exportDataLoading = false;
            });

            const{state, msg} = res.data;
            
            if(state !== '1') {
                return this.$message.error(msg || '下载失败');
            }


            this.$confirm('下载任务创建成功,可以在下载任务列表查看', '提示', {
                confirmButtonText: '立即查看',
                cancelButtonText: '稍后再看',
                type: 'success',
                center: true,
                closeOnClickModal: false
            }).then(() => {
                this.$router.push({path:'/workbench/downloadList'})
            }).catch(() => {})

            // downloadFileTmp(result.url, '演出退款.xlsx');
        }
    }
}
</script>